export default "__VITE_ASSET__205f4908__"